import { RunContextApp } from "framework/RCApp";
import { EVLOAD_ACTIONS_TYPES } from "store/actions/evLoadActions";

export interface EVLOADReducerState {
  refreshLoad : boolean;
}

export interface EVLOADReducerAction {
  type: string;
  payload?: any;
}

const defaultState: EVLOADReducerState = {
  refreshLoad: false
};

export const evLoadReducer = (rc: RunContextApp) => (
  state = { ...defaultState } as EVLOADReducerState,
  action: EVLOADReducerAction
) => {
  switch (action.type) {
    case EVLOAD_ACTIONS_TYPES.REFRESH_EV_LOAD:
      return {
        ...state,
        refreshLoad: action.payload
      };
    default:
      return state;
  }
};
